import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { t } from "../../i18n";

const API_URL = process.env.REACT_APP_API_URL || "https://b.supchats.com";

function pushDataLayerEvent(eventName, extra = {}) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...extra });
  } catch (e) {
    console.error(`Failed to push ${eventName} event:`, e);
  }
}

export default function EmailVerificationPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [status, setStatus] = useState("loading"); // 'loading', 'success', 'error'
  const [message, setMessage] = useState("");

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const pathParts = location.pathname.split("/");
        const token = pathParts[pathParts.length - 1];

        if (!token) {
          setStatus("error");
          setMessage(t("Invalid verification link"));
          return;
        }

        const response = await axios.get(`${API_URL}/verify-email/${token}`);

        if (response.status === 200) {
          if (response.data?.email_verified_event) {
            pushDataLayerEvent("email_verified");
          }
          setStatus("success");
          setMessage(t("Email verified successfully! You can now sign in."));
        }
      } catch (error) {
        console.error("Email verification error:", error);
        setStatus("error");
        if (error.response?.status === 400) {
          setMessage(
            t(
              "Verification link is invalid or has expired. Please try registering again."
            )
          );
        } else {
          setMessage(t("Verification failed. Please try again later."));
        }
      }
    };

    verifyEmail();
  }, [location.pathname]);

  return (
    <div className="auth-container">
      <div className="auth-form">
        <div className="auth-header">
          <h2>{t("Email Verification")}</h2>
        </div>

        <div className="auth-content">
          {status === "loading" && (
            <div className="verification-status">
              <p>{t("Verifying your email...")}</p>
            </div>
          )}

          {status === "success" && (
            <div className="verification-status success">
              <h3>✅ {t("Email Verified Successfully!")}</h3>
              <p>{message}</p>
              <button className="auth-button" onClick={() => navigate("/?login=1")}>
                {t("Sign In")}
              </button>
            </div>
          )}

          {status === "error" && (
            <div className="verification-status error">
              <h3>❌ {t("Verification Failed")}</h3>
              <p>{message}</p>
              <button className="auth-button" onClick={() => navigate("/?login=1")}>
                {t("Go to Sign In")}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

